export function dobToDate(dateOfBirth: { day: number; month: number; year: number }) {
  return new Date(Number(dateOfBirth.year), dateOfBirth.month, dateOfBirth.day);
}
